import type {
  PermissionAccessControlType,
  PermissionEntityType,
  PermissionResourceType,
  UserPermissionType,
} from './types';

type UserPermissionKeyType =
  `${PermissionResourceType}${PermissionEntityType}${PermissionAccessControlType}`;

// Mirrors Gasbi.Crm.Contracts.Constants.CrmPermissions
export const UserPermissions: Partial<
  Record<UserPermissionKeyType, UserPermissionType>
> = {
  // Клієнти
  ClientsIndividualsRead: 'clients.individuals.read',
  ClientsIndividualsWrite: 'clients.individuals.write',
  ClientsLegalEntitiesRead: 'clients.legalentities.read',
  ClientsLegalEntitiesWrite: 'clients.legalentities.write',

  // Сервіс
  ServiceAppealsRead: 'service.appeals.read',
  ServiceAppealsWrite: 'service.appeals.write',
  ServiceSurveysRead: 'service.surveys.read',
  ServiceSurveysWrite: 'service.surveys.write',
  ServiceInformingRead: 'service.informing.read',
  ServiceInformingWrite: 'service.informing.write',
  ServiceContractConclusionRead: 'service.contractconclusion.read',
  ServiceContractConclusionWrite: 'service.contractconclusion.write',
  ServiceWorkflowsRead: 'service.workflows.read',
  ServiceWorkflowsWrite: 'service.workflows.write',
  ServiceTagManagementRead: 'service.tagmanagement.read',
  ServiceTagManagementWrite: 'service.tagmanagement.write',

  // Налаштування
  SettingsGeneralRead: 'settings.general.read',
  SettingsGeneralWrite: 'settings.general.write',
  SettingsAppealsRead: 'settings.appeals.read',
  SettingsAppealsWrite: 'settings.appeals.write',
  SettingsContractConclusionRead: 'settings.contractconclusion.read',
  SettingsContractConclusionWrite: 'settings.contractconclusion.write',
  SettingsInformingRead: 'settings.informing.read',
  SettingsInformingWrite: 'settings.informing.write',

  // Звіти та аналітика
  ReportsAndAnalyticsBiDashboardsRead: 'reportsandanalytics.bidashboards.read',

  // Організації
  OrganizationsOrganizationRead: 'organizations.organization.read',
  OrganizationsOrganizationManage: 'organizations.organization.manage',
  OrganizationsEmployeeRead: 'organizations.employee.read',
  OrganizationsEmployeeManage: 'organizations.employee.manage',
  OrganizationsRoleAndPermissionRead: 'organizations.roleandpermission.read',
  OrganizationsRoleAndPermissionManage:
    'organizations.roleandpermission.manage',
};
